// Relative to the axios base URL, which already appends /api (src/utils/axios.ts).
//
// All five are GET and read-only, and all are [Authorize(Roles = "Admin")] on the API with no
// MenuOptions claim — see AdminRoute.tsx for why the frontend gate mirrors that exactly.
export const CLIENT_REPORTS_ENDPOINTS = {
	// Report 1 — clients whose last-EVER order falls inside a window.
	stoppedOrdering: "Reports/clients-stopped-ordering",
	stoppedOrderingExport: "Reports/clients-stopped-ordering/export",
	// Report 2 — clients with zero orders INSIDE a window, whatever happened around it.
	withoutOrders: "Reports/clients-without-orders",
	withoutOrdersExport: "Reports/clients-without-orders/export",
	// Report 3 — one client's active-vs-silent day split. No export; it is a single record.
	clientOrderActivity: "Reports/client-order-activity",
} as const;
